<template>
	<div>
		<ol class="breadcrumb float-xl-end">
			<li class="breadcrumb-item"><router-link to="/users">Felhasználók</router-link></li>
			<li class="breadcrumb-item active">{{user.name}}</li>
		</ol>
		<h1 class="page-header"><i class="fa fa-user-pen"></i> Felhasználó foglalásai</h1>
		<Loading v-if="bookings === false" title="Foglalások betöltése"></Loading>
		<NoRecords v-else-if="!bookings.length" main_icon="fas fa-cancel" value="false" title="Nem található foglalás"></NoRecords>
		<vue-good-table v-else
						:columns="columns" 
						:rows="bookings" 
						styleClass="vgt-table striped"
					>
						<template slot="table-row" slot-scope="props">
							<span v-if="props.column.field == 'actions'">
								<router-link :to="'/bookings/'+props.row.id" class="btn btn-success btn-xs mx-1" title="foglaláshoz"><i class="fa fa-arrow-right"></i></router-link>								
							</span>
							<span v-else>
								{{props.formattedRow[props.column.field]}}
							</span>
						</template>
					</vue-good-table>
	</div>
</template>

<script>
	import User from "../../apis/User";

	export default {
		data() {
			return {
				columns: [
					{
						label: 'Azonosító',
						field: 'id',
						tdClass: 'text-end',
					},
					{
						label: 'Vendégház',
						field: 'house.name'
					},
					{
						label: 'Szobák',
						field: 'rooms',
						formatFn: this.formatRooms
					},
					{
						label: 'Érkezés',
						field: 'arrive_at',
						formatFn: this.formatDate,
					},
					{
						label: 'Távozás',
						field: 'leave_at',
						formatFn: this.formatDate,
					},
					{
						label: 'Éj',
						field: 'nights',
						tdClass: 'text-end',
					},
					{
						label: 'Ár',
						field: 'price',
						tdClass: 'text-end',
						formatFn: this.formatPrice,
					},
					{
						label: 'Státusz',
						field: 'status_name',
					},
					{
						label: 'Műveletek',
						field: 'actions',
						width: '15%',
						sortable: false,
						tdClass: 'text-end',
					}  
				],
				user:false,
				bookings:false,
				loading: false,
				errors: [],
			}
		},
		created() {			
			User.show(this.$route.params.id)
			.then(response => {
				this.user = response.data;
			});
			User.bookings(this.$route.params.id)
			.then(response => {
				this.bookings = response.data;
			});
		},
		methods: {
			formatDate(value) {
				return value.substring(0,10);
			},
			formatRooms(value) {
				return value.map(r => r.room).join(', ');
			
			},
			formatPrice(value) {
				return value.toLocaleString("hu-HU")
			}
		}
	}
</script>

<style>
	
</style>